/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { lockSeat, unlockSeat } from 'api/seat'
import { useState } from 'react'

export const useSeatLocking = (eventId: string, sessionId: string) => {
    const [unlockTimers, setUnlockTimers] = useState<Record<string, NodeJS.Timeout | null>>({})
    const [lockingInProgress, setLockingInProgress] = useState(false)

    const lockTicketHandler = async (seatId: string) => {
        if (lockingInProgress) return false
        try {
            setLockingInProgress(true)
            cancelUnlockTimer(seatId)

            await lockSeat(seatId, eventId, sessionId)

            return true
        } catch (error) {
            console.error('Error locking seat:', error)
            return false
        } finally {
            setLockingInProgress(false)
        }
    }

    const unlockTicketHandler = async (seatId: string) => {
        try {
            await unlockSeat(seatId, eventId, sessionId)

            return true
        } catch (error) {
            console.error('Error unlocking seat:', error)
            return false
        }
    }

    const startUnlockTimer = (seatId: string) => {
        setUnlockTimers((prev) => {
            if (prev[seatId]) return prev

            const timer = setTimeout(() => {
                unlockTicketHandler(seatId)
                setUnlockTimers((prevTimers) => {
                    const { [seatId]: _, ...rest } = prevTimers
                    return rest
                })
            }, 5000)

            return { ...prev, [seatId]: timer }
        })
    }

    const cancelUnlockTimer = (seatId: string) => {
        setUnlockTimers((prev) => {
            const timer = prev[seatId]
            if (timer) clearTimeout(timer)

            const { [seatId]: _, ...rest } = prev
            return rest
        })
    }

    return {
        lockTicketHandler,
        unlockTicketHandler,
        startUnlockTimer,
        cancelUnlockTimer,
    }
}
